/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Calibration_Temperature_Last_UpdateInputs */



/**
* | output |
* | --- |
* | "Last calibration {date}" |
*
* @param {Calibration_Temperature_Last_UpdateInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calibration_temperature_last_update = /** @type {((inputs: Calibration_Temperature_Last_UpdateInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calibration_Temperature_Last_UpdateInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Last calibration ${i?.date}`)
	return /** @type {LocalizedString} */ (`Dernier calibrage ${i?.date}`)
});